module.exports = "/_next/static/images/trending-family-ab8f8c19526e7468f6715639108418ad.jpg";